import styled from "styled-components";

import { MapLibreMapHost } from "@ryde/controls";
import { IStyledAttributes } from "@ryde/shared";

export const PolygonViewerStyled = styled(
  MapLibreMapHost,
).attrs<IStyledAttributes>({
  "data-e2e": "polygon-viewer",
})`
  height: 400px;
  width: 100%;
`;
